import { BN, Wallet } from "@coral-xyz/anchor";
import { Connection, PublicKey } from "@solana/web3.js";
import Big from "big.js";

import { ToastService } from "@/components/ToastService";
import { TOAST_ID } from "@/constants";
import { TrustResponseData } from "@/interfaces/api";
import { delay, hexToBytes } from "@/utils";
import { secToMilliseconds } from "@/utils/date";

import { hapiApi } from "../api/hapi";
import { config } from "../config";
import { AttestationProgram } from "../contracts/solana";

const mintScore = async ({
  address,
  wallet,
  connection,
  retrievedScores,
  manualUpdate,
  isUpdateMint,
}: {
  address: string;
  wallet: Wallet;
  connection: Connection;
  retrievedScores?: TrustResponseData;
  isUpdateMint?: boolean;
  manualUpdate: (data: { trustScore: number; expirationDate: number }) => void;
}) => {
  try {
    if (!wallet || !address || !retrievedScores) return false;
    const attestationAdaptor = new AttestationProgram(connection, wallet as Wallet, config.solana.attestation);
    const userAttest = await attestationAdaptor.attestUser(
      Array.from(hexToBytes(retrievedScores.signature)),
      Number(retrievedScores?.recovery_id) ?? 0,
      retrievedScores.trust,
      new BN(secToMilliseconds(retrievedScores.expiration)),
      isUpdateMint,
    );
    await delay(2000);
    if (userAttest) {
      const userData = await attestationAdaptor.getUserData(new PublicKey(address));

      manualUpdate({
        trustScore: Number(userData.score),
        expirationDate: Big(userData.expirationDate).toNumber(),
      });

      await hapiApi.logAttest({ chain: -2, address, method: isUpdateMint ? 1 : 0 }); //method - 0 attest | method - 1 replace
      if (userData.score === retrievedScores.trust) {
        return true;
      } else {
        return false;
      }
    }
    return false;
  } catch (e) {
    ToastService.clear(TOAST_ID.AIRDROPS);
    console.warn("Error while signing Solana transaction", e);
    return false;
  }
};

const mintNft = async () => {
  return false;
};

export default {
  mintNft,
  mintScore,
};
